import styles from './PianoDiagram.module.css';

const WHITE_STEPS = [0, 2, 4, 5, 7, 9, 11];
/** Black keys: semitone and the white key they sit after. */
const BLACK_KEYS: [number, number][] = [
  [1, 0],
  [3, 1],
  [6, 3],
  [8, 4],
  [10, 5],
];
const WHITE_WIDTH = 22;

interface PianoDiagramProps {
  /** Keys to light, counted in semitones from the first C; the first is the root. */
  keys: number[];
  /** Octaves shown (default 2; the keyboard view shows 4). */
  octaves?: number;
}

/** Keyboard: the root in accent, other chord tones lighter (F4.4, F4.5, F4.8). */
export function PianoDiagram({ keys, octaves = 2 }: PianoDiagramProps) {
  const whites = 7 * octaves;
  const state = (semitone: number) =>
    keys[0] === semitone ? 'root' : keys.includes(semitone) ? 'tone' : undefined;
  return (
    <div
      className={styles.piano}
      style={{ width: whites * (WHITE_WIDTH - 1) + 1 }}
      aria-hidden="true"
    >
      <div className={styles.whites}>
        {Array.from({ length: whites }, (_, k) => {
          const semitone = Math.floor(k / 7) * 12 + (WHITE_STEPS[k % 7] ?? 0);
          return <span key={k} className={styles.white} data-state={state(semitone)} />;
        })}
      </div>
      {Array.from({ length: octaves }, (_, o) => o).flatMap((octave) =>
        BLACK_KEYS.map(([step, after]) => {
          const semitone = octave * 12 + step;
          return (
            <span
              key={semitone}
              className={styles.black}
              data-state={state(semitone)}
              style={{ left: (octave * 7 + after + 1) * (WHITE_WIDTH - 1) - 7 }}
            />
          );
        }),
      )}
    </div>
  );
}
